module.exports = __webpack_public_path__ + "static/img/resource-img.00fd4799.png";